import { html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { PageContent } from 'src/pages/page-content.js';
import { t } from 'src/i18n';
import 'src/utilities/display-alert';
import '../../content/d-entity-header.js';
import '../../library/components/d-help-section.js';
import '../../library/elements/d-action.js';
import type { PageViewModel } from '@trinnvis/dabih-api-client';
import { features } from '../../store/selectors/features/features';
import { registerItemsPromptStyles } from 'src/library/register-items-prompt-styles';
import { isEmpty } from 'lodash';
import { uuid } from 'src/utilities/text';
import { pageIds } from 'src/store/selectors/pages/pageIds';
import type { CollectionsPageViewModel } from './collections-page-view-model';
import type { CreateCollectionInput } from '../../layout/parts/create-collection-input';
import type { CreateEntityInput } from '../../layout/parts/create-entity-input';

/**
 *
 */
@customElement('d-collections-page-content')
export class DCollectionsPageContent extends PageContent<CollectionsPageViewModel> {
  static readonly styles = [
    ...super.styles,
    registerItemsPromptStyles,
    css`
      d-list-section {
        margin-top: 12px;
      }
    `,
  ];
  @property({ type: Array })
  pages: PageViewModel[] = [];
  @property({ type: Boolean, attribute: 'write-access', reflect: true })
  writeAccess = false;
  @property({ type: Boolean })
  editMode = false;
  @property({ type: Object })
  token = {};
  @property({ type: Boolean })
  uncoverPageMenu = false;
  @property({ type: String })
  key = '';

  renderRegisterItemsPrompt() {
    return html`<div class="register-items-prompt collections" @click=${() => this.onCreateCollection()}>
      <h2>${t('collections.noCollectionsCreated')}</h2>
      <p>${t('collections.emptyInfoText')}</p>
      ${this.pageView.writeAccess ? html` <p>${t('collections.createPrompt')}</p>` : nothing}
    </div>`;
  }

  renderContent() {
    if (this.pageView.promoData) {
      return html` <d-promo-section
        theme-page
        .employeesCount=${this.pageView.employeesCount}
        .specialTerms=${this.pageView.specialTerms}
        .promoData=${this.pageView.promoData}
        .features=${features}
      ></d-promo-section>`;
    }
    return html`
      ${isEmpty(this.pageView.collections)
        ? this.renderRegisterItemsPrompt()
        : html`
            <d-list-section
              no-header
              icon="collections"
              label="${t('collections.title')}"
              .items=${this.pageView.collections}
              theme-page
              .contentStickyTop=${this.contentStickyTop}
            >
            </d-list-section>
          `}
    `;
  }

  private onCreateCollection() {
    if (this.pageView.writeAccess) {
      const id = uuid();
      const input: CreateCollectionInput = {
        entityType: 'collections',
        entityUuid: id,
        pageId: 0,
        targetUrl:
          '/account/' + this.pageView.organizationId + '/' + pageIds.collections + '/collections/' + id + '?edit',
      };
      this.dispatchEvent(
        new CustomEvent<CreateEntityInput>('create-entity', {
          bubbles: true,
          composed: true,
          detail: input,
        }),
      );
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-collections-page-content': DCollectionsPageContent;
  }
}
